import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';
import { createFieldId, describedBy, FieldErrorState } from '../text-input/field-id';

@Component({
  selector: 'ngx-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true,
    },
  ],
})
export class TextAreaComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy, ControlValueAccessor {
  @Input() label = '';
  @Input() readonly = false;
  @Input() disable = false;
  @Input() require = false;
  @Input() pattern = '';
  @Input() patternError = '';
  @Input() fireAlert = false;
  @Input() placeholder: string;
  /** Id of the inner <textarea>; pass it when an outer <label for> must point at this control. */
  @Input() inputId: string = createFieldId('uc-text-area');
  /** Optional guidance shown under the control and announced through aria-describedby. */
  @Input() helperText: string;

  @ViewChild('field', { static: false }) fieldModel: NgModel;

  constructor(private cdr: ChangeDetectorRef) { }

  _inputValue = undefined;
  get inputValue() {
    return this._inputValue;
  }
  set inputValue(val) {
    this._inputValue = val;
    this.propagateChange(this._inputValue);
  }

  propagateChange = (_: any) => { };
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched() { }
  writeValue(value: any) {
    if (value !== undefined) {
      this.inputValue = value;
    }
  }

  get labelId(): string {
    return `${this.inputId}-label`;
  }

  get helperId(): string {
    return `${this.inputId}-helper`;
  }

  get errorId(): string {
    return `${this.inputId}-error`;
  }

  /** Settled error flag shared by aria-invalid, aria-describedby and the error message (see FieldErrorState). */
  readonly errorState = new FieldErrorState(
    () => this.cdr.markForCheck(),
    (model) => !!(model?.errors && (model.touched || this.fireAlert))
  );

  get errorShown(): boolean {
    return this.errorState.first;
  }

  get describedByIds(): string | null {
    return describedBy(this.helperText && this.helperId, this.errorShown && this.errorId);
  }

  ngOnChanges(): void {
    this.errorState.schedule();
  }

  ngAfterViewInit(): void {
    this.errorState.watch([this.fieldModel]);
  }

  ngOnDestroy(): void {
    this.errorState.destroy();
  }

  ngOnInit() { }
}
